// extracted by mini-css-extract-plugin
export var noSpinners = "_o9-6";
export var percentageInput = "_o9-7";
export var variantColor1 = "_o9-0";
export var variantColor2 = "_o9-1";
export var variantColor3 = "_o9-2";
export var variantColor4 = "_o9-3";
export var variantColor5 = "_o9-4";
export var variantColor6 = "_o9-5";